import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';

import { PromotionalBanner } from '../../../components/promotional-banner';
import { useIsEnhancedReturnsFeatureEnabled } from '../../../store/returns/returns.helpers';
import { useIsFeatureIncludedInAnyBillingPlan } from '../../settings/payment-and-subscription/hooks/use-plan-details';
import { Features } from '../../../constants/features';
import Global from '../../../store/global-selectors';
import { getLink } from '../../../services/link-service';
import { linkIDs } from '../../../services/link-service/links';
import { useGlobalModalLaunchContext } from '../../../contexts/modal-context/global-modal-context';

import { messages } from './messages';
import styles from './styles.module.less';

export const EnhancedReturnsPromotionalBanner = () => {
  const isEnhancedReturnsFeatureEnabled = useIsEnhancedReturnsFeatureEnabled();
  const isAbleToAcquire = useIsFeatureIncludedInAnyBillingPlan(Features.EnhancedReturns);

  const { openManageSubscriptionDrawer } = useGlobalModalLaunchContext();
  const intl = useIntl();
  const supportCountry = useSelector((state) => Global.selectSellerSupportCountry(state));
  const helpArticleHref = getLink(linkIDs.EnhancedReturns, supportCountry, intl.locale);

  if (isEnhancedReturnsFeatureEnabled || !isAbleToAcquire) {
    return null;
  }

  return (
    <div className={styles.bannerContainer}>
      <PromotionalBanner
        className={styles.banner}
        promotionalHeaderMessage={messages.bannerTitle}
        promotionalSubheaderMessage={messages.bannerSubtitle}
      >
        <Button onClick={openManageSubscriptionDrawer} theme='promotional'>
          <FormattedMessage {...messages.upgrade} />
        </Button>
        <Button href={helpArticleHref} theme='link'>
          <FormattedMessage {...messages.learnMore} />
        </Button>
      </PromotionalBanner>
    </div>
  );
};
